import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const KPI = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [level1Rows, setLevel1Rows] = useState([]);
    const [level1Columns, setLevel1Columns] = useState([]);
    const [level2Rows, setLevel2Rows] = useState([]);
    const [level2Columns, setLevel2Columns] = useState([]);
    const [level3Rows, setLevel3Rows] = useState([]);
    const [level3Columns, setLevel3Columns] = useState([]);
    const [tabID, setTabID] = useState('1');
    const [keyword, setKeyword] = useState({
        start_date: Moment().format("YYYY-MM-01"),
        end_date: appStore.YYYY_MM_DD(),
        certkey: ''
    });

    // Grid정의
    const handleSetting = () => {
        setLevel1Columns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'kpi_date', headerName: '일자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'kpi_datetime', headerName: '발생일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_operation_yn', headerName: '가동여부', width: 120, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_datetime', headerName: '전송일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_code', headerName: '전송코드', width: 0, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_msg', headerName: '전송메시지', width: 400, headerAlign: 'center', align:'left' }
        ]);
        
        setLevel2Columns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'kpi_date', headerName: '일자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'kpi_datetime', headerName: '발생일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_field_code', headerName: '성과지표분야코드', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_detail_code', headerName: '세부성과지표코드', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_detail_name', headerName: '세부성과지표명', width: 150, headerAlign: 'center', align:'center' },
            { field: 'kpi_improvement', headerName: '성취률(%)', width: 120, headerAlign: 'center', align:'right' },
            { field: 'kpi_improvement_basis', headerName: '성취률 근거', width: 250, headerAlign: 'center', align:'left' },
            { field: 'kpi_transper_datetime', headerName: '전송일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_code', headerName: '전송코드', width: 0, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_msg', headerName: '전송메시지', width: 400, headerAlign: 'center', align:'left' }
        ]);

        setLevel3Columns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'kpi_date', headerName: '일자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'kpi_datetime', headerName: '발생일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_field_code', headerName: '성과지표분야코드', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_detail_code', headerName: '세부성과지표코드', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_detail_name', headerName: '세부성과지표명', width: 150, headerAlign: 'center', align:'center' },
            { field: 'kpi_measurement_value', headerName: '측정수치', width: 120, headerAlign: 'center', align:'right' },
            { field: 'kpi_measurement_value_basis', headerName: '측정수치 근거', width: 250, headerAlign: 'center', align:'left' },
            { field: 'kpi_measurement_unit', headerName: '단위', width: 80, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_datetime', headerName: '전송일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_code', headerName: '전송코드', width: 0, headerAlign: 'center', align:'center' },
            { field: 'kpi_transper_msg', headerName: '전송메시지', width: 400, headerAlign: 'center', align:'left' }
        ]);
    }

    const [level1ColumnVisibilityModel, setLevel1ColumnVisibilityModel] = useState({
        id: false,
        kpi_date: true,
        kpi_datetime: true,
        kpi_operation_yn: true,
        kpi_transper_datetime: true,
        kpi_transper_code: false,
        kpi_transper_msg: true
    });

    const [level2ColumnVisibilityModel, setLevel2ColumnVisibilityModel] = useState({
        id: false,
        kpi_date: true,
        kpi_datetime: true,
        kpi_field_code: true,
        kpi_detail_code: true,
        kpi_detail_name: true,
        kpi_improvement: true,
        kpi_improvement_basis: false,
        kpi_transper_datetime: true,
        kpi_transper_code: false,
        kpi_transper_msg: true
    });

    const [level3ColumnVisibilityModel, setLevel3ColumnVisibilityModel] = useState({
        id: false,
        kpi_date: true,
        kpi_datetime: true,
        kpi_field_code: true,
        kpi_detail_code: true,
        kpi_detail_name: true,
        kpi_measurement_value: true,
        kpi_measurement_value_basis: false,
        kpi_measurement_unit: true,
        kpi_transper_datetime: true,
        kpi_transper_code: false,
        kpi_transper_msg: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        
            axios.get('/api/p/KPI/Key')
            .then((response) => {
                const nextKeyword = {
                    ...keyword,
                    ['certkey'] : response.data
                };
                setKeyword(nextKeyword);
            });
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.start_date, keyword.end_date, keyword.certkey, tabID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/KPI/List',
            {
            params : {
                level : tabID,
                start_date : keyword.start_date,
                end_date : keyword.end_date,
                certkey : keyword.certkey
            }
        },
        { withCredentials: true }
        )
        .then((response) => { // Rows 저장
            let array = [];
            if(tabID === '1'){
                array = response.data.map((item, index) => ({
                    id: index,
                    kpi_date: item.kpi_date,
                    kpi_datetime: (item.kpi_datetime === undefined?'':Moment(item.kpi_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    kpi_operation_yn: item.kpi_operation_yn,
                    kpi_transper_datetime: (item.kpi_transper_datetime === undefined?'':Moment(item.kpi_transper_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    kpi_transper_code: (item.kpi_transper_code === undefined?'':item.kpi_transper_code),
                    kpi_transper_msg: (item.kpi_transper_msg === undefined?'':item.kpi_transper_msg)
                }));
                setLevel1Rows(array);
            }else if(tabID === '2'){
                array = response.data.map((item, index) => ({
                    id: index,
                    kpi_date: item.kpi_date,
                    kpi_datetime: (item.kpi_datetime === undefined?'':Moment(item.kpi_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    kpi_field_code: item.kpi_field_code,
                    kpi_detail_code: item.kpi_detail_code,
                    kpi_detail_name: item.kpi_detail_name,
                    kpi_improvement: item.kpi_improvement,
                    kpi_improvement_basis: item.kpi_improvement_basis,
                    kpi_transper_datetime: (item.kpi_transper_datetime === undefined?'':Moment(item.kpi_transper_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    kpi_transper_code: (item.kpi_transper_code === undefined?'':item.kpi_transper_code),
                    kpi_transper_msg: (item.kpi_transper_msg === undefined?'':item.kpi_transper_msg)
                }));
                setLevel2Rows(array);
            }else if(tabID === '3'){
                array = response.data.map((item, index) => ({
                    id: index,
                    kpi_date: item.kpi_date,
                    kpi_datetime: (item.kpi_datetime === undefined?'':Moment(item.kpi_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    kpi_field_code: item.kpi_field_code,
                    kpi_detail_code: item.kpi_detail_code,
                    kpi_detail_name: item.kpi_detail_name,
                    kpi_measurement_value: item.kpi_measurement_value,
                    kpi_measurement_value_basis: item.kpi_measurement_value_basis,
                    kpi_measurement_unit: item.kpi_measurement_unit,
                    kpi_transper_datetime: (item.kpi_transper_datetime === undefined?'':Moment(item.kpi_transper_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    kpi_transper_code: (item.kpi_transper_code === undefined?'':item.kpi_transper_code),
                    kpi_transper_msg: (item.kpi_transper_msg === undefined?'':item.kpi_transper_msg)
                }));
                setLevel3Rows(array);
            }
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    const handleInit = () => {
        
        // Hide컬럼 숨기기.
        setLevel1ColumnVisibilityModel({
            id: false,
            kpi_date: true,
            kpi_datetime: true,
            kpi_operation_yn: true,
            kpi_transper_datetime: true,
            kpi_transper_code: false,
            kpi_transper_msg: true
        });

        setLevel2ColumnVisibilityModel({
            id: false,
            kpi_date: true,
            kpi_datetime: true,
            kpi_field_code: true,
            kpi_detail_code: true,
            kpi_detail_name: true,
            kpi_improvement: true,
            kpi_improvement_basis: String(localStorage.getItem("kpi_basis_yn")) === 'Y'?true:false,
            kpi_transper_datetime: true,
            kpi_transper_code: false,
            kpi_transper_msg: true
        });

        setLevel3ColumnVisibilityModel({
            id: false,
            kpi_date: true,
            kpi_datetime: true,
            kpi_field_code: true,
            kpi_detail_code: true,
            kpi_detail_name: true,
            kpi_measurement_value: true,
            kpi_measurement_value_basis: String(localStorage.getItem("kpi_basis_yn")) === 'Y'?true:false,
            kpi_measurement_unit: true,
            kpi_transper_datetime: true,
            kpi_transper_code: false,
            kpi_transper_msg: true
        });
    };

    const onDateChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
    };

    const handleSend = () => {
        axios.post("/api/p/KPI/Send", new URLSearchParams({
            target_date : keyword.start_date
         }),
         { withCredentials: true })
        .then(function (response) {
            if(response.status === 200){
                Swal.fire({
                    title: 'KPI 전송 완료',
                    text: '정상적으로 KPI가 전송 되었습니다.',
                    confirmButtonText: '확인',
                    timer:5000,
                    timerProgressBar: true
                });
            }else{
                appStore.capture();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
        .then(function () {
            handleView();
        });
    };

    const handleExcel = () => {
        var filename = 'KPI'
        axios.get('/api/p/KPI/Excel',
        {   
            params : { start_date : keyword.start_date, end_date : keyword.end_date, certkey : keyword.certkey, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    {/* <Button 
                        onClick={ handleSend }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        KPI전송
                    </Button>   */}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            인증키
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '320px' } }>
                            <input type="text" placeholder="인증키" value={keyword.certkey} name="certkey" autoComplete="off" style={ { width: '185px' } } disabled={true} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '100px', fontWeight: 'bold' } }>
                            조회기간
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px' } }>
                            <input type="date" value={keyword.start_date} name="start_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                        <div className="menu-keyword-sub-title" style={ { textAlign: 'center', width: '50px' } }>
                            ~
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px'} }>
                            <input type="date" value={keyword.end_date} name="end_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
            <TabContext value={tabID}>
                <Box sx={{ top:'200px', borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                        <Tab label="Level1" value="1" />
                        <Tab label="Level2" value="2" />
                        <Tab label="Level3" value="3" />
                    </TabList>
                </Box>
                    <TabPanel value="1">
                        <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 313px)', fontSize: '17px' } }>

                            <DataGrid
                                className="grid_main"
                                rows={level1Rows}
                                columns={level1Columns}
                                slots={{
                                    noRowsOverlay: GridNoRow,
                                }}
                                columnVisibilityModel={level1ColumnVisibilityModel}
                                AlternatingRowBackground="LavenderBlush"
                                rowsPerPageOptions={[20, 50, 100]}
                            />

                        </div>
                    </TabPanel>
                    <TabPanel value="2">
                        <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 313px)', fontSize: '17px' } }>

                            <DataGrid
                                className="grid_main"
                                rows={level2Rows}
                                columns={level2Columns}
                                slots={{
                                    noRowsOverlay: GridNoRow,
                                }}
                                columnVisibilityModel={level2ColumnVisibilityModel}
                                AlternatingRowBackground="LavenderBlush"
                                rowsPerPageOptions={[20, 50, 100]}
                            />

                        </div>
                    </TabPanel>
                    <TabPanel value="3">
                        <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 313px)', fontSize: '17px' } }>

                            <DataGrid
                                className="grid_main"
                                rows={level3Rows}
                                columns={level3Columns}
                                slots={{
                                    noRowsOverlay: GridNoRow,
                                }}
                                columnVisibilityModel={level3ColumnVisibilityModel}
                                AlternatingRowBackground="LavenderBlush"
                                rowsPerPageOptions={[20, 50, 100]}
                            />

                        </div>
                    </TabPanel>
            </TabContext>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default KPI;
